import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import {
  Typography,
  Box,
  Button,
  Paper,
  Chip
} from '@mui/material'
import ExploreIcon from '@mui/icons-material/Explore'
import AddIcon from '@mui/icons-material/Add'
import AppleIcon from '@mui/icons-material/Apple'
import AndroidIcon from '@mui/icons-material/Android'
import ExploreRowTable from '../components/tables/exploreRowTable'

export default function ExploreRowsPage() {
  const navigate = useNavigate()
  const [platformFilter, setPlatformFilter] = useState('')

  // Debug: Log platform filter changes
  React.useEffect(() => {
    console.log('Platform filter changed:', platformFilter)
  }, [platformFilter])

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 4,
        maxWidth: '1400px',
        mx: 'auto',
        px: 2,
        py: 2,
      }}
    >
      {/* Header */}
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 2
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <ExploreIcon fontSize="large" sx={{ color: '#1976d2' }} />
          <Typography variant="h4" sx={{ fontWeight: 'bold', color: '#1976d2' }}>
            Explore Rows Management
          </Typography>
        </Box>
        
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={() => navigate('/explore-rows/create')}
          sx={{
            backgroundColor: '#1976d2',
            '&:hover': {
              backgroundColor: '#1565c0'
            }
          }}
        >
          Create New Explore Row
        </Button>
      </Box>

      {/* Description */}
      <Box sx={{ mb: 2 }}>
        <Typography variant="body1" color="text.secondary">
          Manage explore rows that define the content display order and highlighting in the explore section. 
          Each row references a specific content item (Prompt, Style, or Section) and can be optionally tagged and highlighted.
        </Typography>
      </Box>

      {/* Platform Filter */}
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexWrap: 'wrap' }}>
        <Typography variant="body2" color="text.secondary" sx={{ mr: 1 }}>
          Platform:
        </Typography>
        <Chip
          icon={<AppleIcon />}
          label="iOS"
          onClick={() => setPlatformFilter(platformFilter === 'IOS' ? '' : 'IOS')}
          variant={platformFilter === 'IOS' ? 'filled' : 'outlined'}
          sx={{
            backgroundColor: platformFilter === 'IOS' ? '#000' : 'transparent',
            color: platformFilter === 'IOS' ? '#fff' : '#000',
            borderColor: platformFilter === 'IOS' ? '#000' : '#ccc',
            '& .MuiChip-icon': { 
              color: platformFilter === 'IOS' ? '#fff' : '#000' 
            },
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: platformFilter === 'IOS' ? '#333' : '#f5f5f5'
            }
          }}
        />
        <Chip
          icon={<AndroidIcon />}
          label="Android"
          onClick={() => setPlatformFilter(platformFilter === 'ANDROID' ? '' : 'ANDROID')}
          variant={platformFilter === 'ANDROID' ? 'filled' : 'outlined'}
          sx={{
            backgroundColor: platformFilter === 'ANDROID' ? '#3DDC84' : 'transparent',
            color: platformFilter === 'ANDROID' ? '#000' : '#000',
            borderColor: platformFilter === 'ANDROID' ? '#3DDC84' : '#ccc',
            '& .MuiChip-icon': { 
              color: '#000'
            },
            cursor: 'pointer',
            '&:hover': {
              backgroundColor: platformFilter === 'ANDROID' ? '#2CCC73' : '#f5f5f5'
            }
          }}
        />
        {platformFilter && (
          <Button
            size="small"
            onClick={() => setPlatformFilter('')}
            sx={{ minWidth: 'auto', p: 0.5 }}
          >
            Clear
          </Button>
        )}
      </Box>

      {/* Explore Rows Table */}
      <Paper elevation={2} sx={{ borderRadius: 2, overflow: 'hidden' }}>
        <ExploreRowTable platformFilter={platformFilter} />
      </Paper>
    </Box>
  )
}
